import { Button, Tag } from 'antd';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  getInvoiceEmailList,
  modifyInvoiceEmailList,
} from '../../../../../api/billing-center/invoice';
import { CommonButton } from '../../../../../components/button/main';
import { CommonCard } from '../../../../../components/card';
import getFormatMessage from '../../../../../locales/get-format-message';
import {
  IAPIFeeCenterMailManageItem,
  IAPIStudioMemberHasPermissionItem,
} from '../../../../../model/api-modules';
import { IRootState } from '../../../../../store/reducers';
import { InvoiceEmailDrawer } from './drawer';
import styles from './index.module.scss';

interface IProps {
  readonly owner?: IAPIStudioMemberHasPermissionItem;
  readonly onChange: (data: IAPIFeeCenterMailManageItem[]) => void;
}

export const InvoiceEmails = (props: IProps) => {
  const { onChange, owner } = props;
  const selectStudio = useSelector(
    (state: IRootState) => state.studio.selectStudio
  );
  const [showDrawer, setShowDrawer] = useState<boolean>(false);

  const [emailList, setEmailList] =
    useState<ReadonlyArray<IAPIFeeCenterMailManageItem>>();

  useEffect(() => {
    init();
  }, [selectStudio?.studioID]);

  const init = async (emails?: IAPIFeeCenterMailManageItem[]) => {
    if (!selectStudio) {
      return;
    }

    const res = emails || (await getInvoiceEmailList(selectStudio.studioID));
    if (res.length) {
      const sortedEmails = [...res].sort((a, b) => (b.isDefault ? 1 : -1));
      setEmailList(res);
      onChange(sortedEmails);
      return;
    }
    if (owner?.UserID) {
      const ownerEmailItem = {
        email: owner.UserID,
        isDefault: true,
        studioID: selectStudio.studioID,
        createTime: new Date().toISOString(),
      };
      await modifyInvoiceEmailList({
        studioID: selectStudio.studioID,
        data: [ownerEmailItem],
      });
      setEmailList([ownerEmailItem]);
      onChange([ownerEmailItem]);
    }
  };

  const renderEmails = () => {
    if (!emailList) {
      return null;
    }
    if (emailList.length === 0) {
      return (
        <div>
          <span>{getFormatMessage('请')}</span>
          <Button
            type="link"
            onClick={() => {
              setShowDrawer(true);
            }}
          >
            {getFormatMessage('添加邮箱')}
          </Button>
        </div>
      );
    }
    const getMailItem = (mailItem: IAPIFeeCenterMailManageItem) => {
      return (
        <div className={styles.emailCell}>
          <span>{mailItem.email}</span>
          {mailItem.isDefault && (
            <Tag color="#5764f11a">
              <span style={{ color: '#5764F1' }}>
                {getFormatMessage('email_default')}
              </span>
            </Tag>
          )}
        </div>
      );
    };

    if (emailList.length > 2) {
      return (
        <>
          <div>{getMailItem(emailList[0])}</div>
          <div>{getMailItem(emailList[1])}</div>
          <CommonButton type="link" onClick={() => setShowDrawer(true)}>
            {getFormatMessage('更多')}
          </CommonButton>
        </>
      );
    }

    return <>{emailList.map((item) => getMailItem(item))}</>;
  };

  return (
    <CommonCard
      title={getFormatMessage('email_info')}
      extra={
        <CommonButton
          onClick={() => {
            setShowDrawer(true);
          }}
        >
          {getFormatMessage('email_manage')}
        </CommonButton>
      }
    >
      <div className={styles.cardBody}>{renderEmails()}</div>
      {showDrawer && owner && (
        <InvoiceEmailDrawer
          onClose={() => setShowDrawer(false)}
          onChange={(emails) => init(emails)}
          owner={owner}
        />
      )}
    </CommonCard>
  );
};
